"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SalesByProductData_1 = __importDefault(require("../entity/SalesByProductData"));
const ProductStub_1 = __importDefault(require("./ProductStub"));
class SalesByProductDataStub extends SalesByProductData_1.default {
    constructor({ label = 'Test', product = new ProductStub_1.default(), value = 1000, quantity = 1000, } = {}) {
        super({ label, product, value, quantity });
    }
}
exports.default = SalesByProductDataStub;
